export default __webpack_public_path__ + "static/media/about-us.5f504ce4.svg";